export const SET_RESERVATIONS = 'SET_RESERVATIONS';